import { dashboardTypes } from './actionTypes';

const INIT_STATE = {
  filterList: [],
  filterData: {},
  isLoading: false,
  error: {},
};

const Dashboard = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case dashboardTypes.GET_FILTER_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case dashboardTypes.GET_FILTER_LIST_SUCCESS:
      return {
        ...state,
        filterList: action.payload,
        isLoading: false,
      };

    case dashboardTypes.GET_FILTER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case dashboardTypes.GET_FILTER_DATA:
      return {
        ...state,
        isLoading: true,
      };

    case dashboardTypes.GET_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterData: action.payload,
        isLoading: false,
      };
    case dashboardTypes.GET_FILTER_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default Dashboard;
